import IFilter from './IFilter'
import EmptyFilter from './EmptyFilter'
import ObjectIdFactory from "./ObjectIdFactory";

/**
 * This class handle the Terms Filters
 * @author Reynaldo
 * Example
 *  {
        "type": "TERMS",
        "field": "um.id.keyword",
        "value": ["bb4cd88-c6b8-4a77-956a-0671189be008", "a"]
    }
 **/


export default class TermsFilter extends IFilter {

  /**
   * @param filter {Object}
   **/
  constructor(filter) {
    super()
    const {field, values, objectId, isDate} = filter
    this.type = 'TERMS'
    this.field = field
    this.values = values
    this.filterObject = filter
    this.objectId = objectId || false
    this.isDate = isDate || false
  }

  clone() {
    return new TermFilter(this.toQuery())
  }

  toQuery() {
    if (!this.field)
      return this.filterObject

    if (this.values === undefined)
      return
    return {
      type: 'TERMS',
      field: this.field,
      values: this.values,
      objectId: this.objectId,
      isDate: this.isDate,
    }
  }

  /**
   * Converts options to a MongoDB query object.
   *
   * @param {{flat?: boolean, oid?: boolean}| undefined} An optional object containing options for the query.
   * @return {Object} - The MongoDB query object.
   */
  toMongoQuery(options) {
    if (!this.field)
      return this.filterObject
    let nValues = this.values
    if (this.objectId) {
      nValues = ObjectIdFactory.create(nValues, options && options.oid)
    }
    if (this.isDate && Date.parse(nValues)) {
      nValues = new Date(nValues)
    }
    return {[this.field]: nValues}
  }
}
